import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ComponentInternalState {
  editFormOpen: boolean;
  editFormError?: boolean;
  editFormErrorMessage?: string;
}

export interface AddressComponentsState {
  [key: string]: ComponentInternalState;
}

interface SetEditFormPayload {
  name: string;
  editFormOpen?: boolean;
  editFormError?: boolean;
  editFormErrorMessage?: string;
}

export const addressComponentsSlice = createSlice({
  name: 'addressComponents',
  initialState: {} as AddressComponentsState,
  reducers: {
    setEditFormOpen: (state, action: PayloadAction<SetEditFormPayload>) => {
      const { name, editFormOpen = false } = action.payload;
      if (!state[name]) {
        state[name] = { editFormOpen: false };
      }
      state[name].editFormOpen = editFormOpen;
    },
    setEditFormError: (state, action: PayloadAction<SetEditFormPayload>) => {
      const { name, editFormError, editFormErrorMessage } = action.payload;
      if (!state[name]) {
        state[name] = { editFormOpen: false };
      }
      state[name].editFormError = editFormError;
      state[name].editFormErrorMessage = editFormErrorMessage;
    },
    resetAddressComponents: () => {
      return {};
    },
    resetAddressComponent: (state, action) => {
      const { name } = action.payload;
      if (state[name]) {
        state[name] = { editFormOpen: false };
      }
    },
    removeAddressComponent: (state, action) => {
      const { name } = action.payload;
      if (state[name]) {
        delete state[name];
      }
    }
  }
});

export const {
  setEditFormOpen,
  setEditFormError,
  resetAddressComponent,
  resetAddressComponents,
  removeAddressComponent
} = addressComponentsSlice.actions;

export default addressComponentsSlice.reducer;
